import React, { useEffect } from 'react'
import Module from '../../layout/Module'
import { 
  useNavigate,
  Routes,
  Route
} from 'react-router-dom'
import ButtonStartIcon from '../../button/ButtonStartIcon'
import List from './List/List'
import Dashboard from './Dashboard/Dashboard'
import FilterButton from './Filter/Button'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter } from '../../../store/actions/filter.actions'
import { getUTCDates } from '../../../utils/date'

const Audit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const today = useSelector(state => state.date.date);
  const timezone = useSelector((state) => state.tenant?.timezone || 'Australia/Victoria');

  useEffect(() => {
    const { start, end } = getUTCDates(today, today, timezone);
    dispatch(updateFilter('audit', { startDate: start, endDate:end }));
  }, [today, timezone])

  return (
    <Module>
      <Module.Header
        title='Audit'
        titleLink={'/dashboard/audit'}
      >
        <ButtonStartIcon
          onClick={() => navigate('list')}
          startIcon='th-list'
          color='secondary'
        >
          List
        </ButtonStartIcon>
      </Module.Header>
      <Module.Body>
        <Module.BodyHeader className='border-b border-b-2 border-primary'>
          <FilterButton />
        </Module.BodyHeader>
        <Module.BodyContainer>
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path='list' element={<List />} />
          </Routes>
        </Module.BodyContainer>
      </Module.Body>
    </Module>
  )
}

export default Audit;
